import { v4 as uuid } from "uuid";
export interface INotification {
  key: string,
  type: string,
  header: string,
  message: string,
  secondsToClose: number,
}

export class NotificationModel implements INotification {
  key: string;
  type: string;
  header: string;
  message: string;
  secondsToClose: number = 20;

  public static readonly NOTIFICATION_TYPE = {
    ALERT: "alert",
    INFO: "info",
    ERROR: "error",
    SUCCES: "success"    
}


  constructor(type, header, message, secondsToClose = null) {
    this.key = uuid().slice(0, 8);
    this.type = type;
    this.header = header;
    this.message = message;
    if(secondsToClose !== null) {
        this.secondsToClose = secondsToClose;
    }
  }      


}